import { TOAST_MESSAGE_HIS_TO_CRM } from "app/common/LocalConst";
import {
  mergePatient,
  mergePatientHisToCrm,
  voidedPatient,
} from "app/services/PatientService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class PatientMergeStore {
  searchPatient = {
    oldCustomer: null,
    newCustomer: null,
  };
  patientSelect = null;
  openConfirmDelete = false;
  openTextMessageMerge = false;  
  textMessageMerge = "";       
  
  // popup confirm khi không trùng tên & SĐT
  openConfirmMerge = false;
  confirmMessage = "";
  mergeCallback = null;
  

  constructor() {
    makeAutoObservable(this);
  }
  // merge khách hàng thường
  mergePatient = async (values) => {
    this.openTextMessageMerge = true;
    this.textMessageMerge = "Bạn có chắc chắn Merge khách hàng không";
    const { oldCustomer, newCustomer, ...ortherData } = values;

    this.mergeCallback = async () => {
    return await mergePatient({
      oldId: oldCustomer?.id,
      newId: newCustomer?.id,
    })
      .then(({ data }) => {
        // if (data?.mergeToCrmResult) {
        // }
        this.textMessageMerge = data?.mergeToCrmResultStr;
        this.openTextMessageMerge = false;
        // this.openTextMessageMerge = data?.mergeToCrmResultStr;
        toast.success("Merge dữ liệu khách hàng thành công");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Merge dữ liệu khách hàng có lỗi");
      });
    }
  };
  // merge HIS → CRM
  mergeHisToCrm = async (values) => {
    this.openTextMessageMerge = true;
    this.textMessageMerge = "Bạn có chắc chắn Merge khách hàng không";
    const { oldCustomer, newCustomer, ...ortherData } = values;

    this.mergeCallback = async () => {
      if (oldCustomer.id === newCustomer.id) {
        this.openTextMessageMerge = false;
        toast.error("Không thể merge vì 2 khách hàng trùng ID");
        return;
      }
      //  // check trùng tên và số điện thoại
      // const sameName =
      //   oldCustomer?.displayName?.trim() === newCustomer?.displayName?.trim();
      // const samePhone =
      //   oldCustomer?.phoneNumber?.trim() === newCustomer?.phoneNumber?.trim();

      // if (!sameName && !samePhone) {
      //   this.openConfirmMerge = true;
      //   this.confirmMessage = "Hai khách hàng này không trùng tên và số điện thoại. Bạn có chắc chắn muốn gộp không?";
      //   // lưu lại callback API thật
      //   this.mergeCallback = async () => {
      //     try {
      //       const { data } = await mergePatient({
      //         oldId: oldCustomer?.id,
      //         newId: newCustomer?.id,
      //       });
      //       this.confirmMessage = data?.mergeToCrmResultStr ;
      //       toast.success("Merge dữ liệu khách hàng thành công");
      //     } catch (error) {
      //       console.error(error);
      //       toast.error("Merge dữ liệu khách hàng có lỗi");
      //     } finally {
      //       this.openConfirmMerge = false;
      //       this.confirmMessage = false;
      //     }
      //   };
      //   return;
      // }
      return await mergePatientHisToCrm({
        oldId: oldCustomer?.id,
        newId: newCustomer?.id,
        syncToCRm: true,
      })
        .then(({ data }) => {
          // if (data?.mergeToCrmResult) {
          // }
          this.textMessageMerge = data?.mergeToCrmResultStr;
          this.openTextMessageMerge = false;
          // this.openTextMessageMerge = data?.mergeToCrmResultStr;
          toast.success("Merge dữ liệu his sang crm thành công");
        })
        .catch((error) => {
          console.error(error);
          toast.error("Merge dữ liệu his sang crm có lỗi");
        });
    }
  };
  
  handleCloseConfirmMerge = () => {
    this.openConfirmMerge = false;
    this.confirmMessage = "";
  };

  handleConfirmMerge = async () => {
    if (this.mergeCallback) {
      await this.mergeCallback();
    }
  };
  handleCloseTextMessageMerge = () => {
    this.openTextMessageMerge = false;
    this.textMessageMerge = "";
  };

  handleDeletePatient = (patient) => {
    this.patientSelect = { id: patient?.id };
    this.openConfirmDelete = true;
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
    this.patientSelect = null;
  };

  handleConfirmDeletePatient = async () => {
    return await voidedPatient(this.patientSelect?.id)
      .then(() => {
        toast.success("Xóa khách hàng thành công!");
        this.openConfirmDelete = false;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
      });
  };
  resetStore = () => {
    this.searchPatient = {
      oldCustomer: null,
      newCustomer: null,
    };
  };
}
